import styled from '@emotion/styled'

export const Background = styled.div`
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    overflow-y: hidden;
    background-color: rgba(0, 0, 0, .65);
`

export const SpinnerBlock = styled.div`
    position: absolute;
    top: 25%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
`

export const Spinner = styled.div`
    color: #ffffff;
    font-size: 5.625rem;
    text-indent: -9999em;
    overflow: hidden;
    width: 1em;
    height: 1em;
    border-radius: 50%;
    margin: 4.5rem auto;
    position: relative;
    transform: translateZ(0);
    animation: load6 1.7s infinite ease, round 1.7s infinite ease;
`

export const LoadingText = styled.p`
    color: white;
    text-align: center;
    font-size: 2rem;
`